import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col } from 'reactstrap';
import AssignmentCategoryCard from './AssignmentCategoryCard';
import Amplify, { Auth } from 'aws-amplify';
import config from '../../aws-exports';
import { UserContext } from '../../components/UserContext';
import EventCategoryCard from '../Card/EventCategoryCard';
// import { ScoreContext } from '../components/ScoreContext'
import Lottie from 'react-lottie';
import { default as animationData } from '../../assets/loader.json';
import { cx } from '@emotion/css';
import * as styles from '../Questions/challanges.style.js';
import batchImg from '../../assets/images/challenge-banner.png';
import { isMobile } from 'react-device-detect';
import {
  withAuthenticator,
  AmplifySignOut,
  ForgotPassword,
} from 'aws-amplify-react';

Amplify.configure(config);
function AssignmentCategoryScreen(props) {
  const [events_category, set_events_category] = useState([]);
  const [userdetails, set_userdetails] = useState({});
  const { user, setUser } = useContext(UserContext);
  const [loadedcategories, set_loadedcategories] = useState(false);

  //  const {score,setScore} = useContext(ScoreContext);

  ////console.log("Calling EventCatScreen.....")

  useEffect(() => {
    // You need to restrict it at some point
    // This is just dummy code and should be replaced by actual
    ////console.log("useEffect called in EventCatScreen")

    getToken();
    document.title = 'My Challenges';
  }, []);


  const getToken = async () => {
    let user = null;
    try {
      user = await Auth.currentAuthenticatedUser();


      Auth.currentSession().then((res) => {
        let accessToken = res.getAccessToken();
        let jwt = accessToken.getJwtToken();
        if (user.username.includes("Google_")) {
          getuserDetails(user.attributes['email'], jwt);
        }
        else {
          getuserDetails(user.username, jwt);

        }




      });




    } catch (error) {
      // console.log(error)
      Auth.signOut();
    }

  };

  // const getToken = async () => {
  //   Auth.currentSession().then((res) => {
  //     ////console.log("Auth.currentSession()")
  //     let accessToken = res.getAccessToken();
  //     ////console.log("accessToken called ")
  //     let jwt = accessToken.getJwtToken();
  //     ////console.log("Got jwt ")
  //     // CreatorUpdateUser(Auth.user.username,jwt)
  //     // ////console.log("Called CreatorUpdateUser")
  //     getuserDetails(Auth.user.username, jwt);
  //     ////console.log("Called getuserDetails")
  //     // getEventsfromDB(Auth.user.username,jwt)
  //     // ////console.log("Called getEventsfromDB")
  //   });
  // };

  const getEventsfromDB = async (username, jwt, batchlist) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },

      body: JSON.stringify({
        username: username,
        eventtype: 'Assignments',
        batchlist: batchlist,
      }),
    };

    const response = await fetch(
      `https://api.dev.quizwizard.net/quiz/assignmentcounts`,
      requestOptions
    );
    const data = await response.json();
    //////console.log('Output from the API is ')
    //////console.log(data)
    set_events_category(data);
    set_loadedcategories(true);

    ////console.log("getEventsfromDB done")
  };
  const getuserDetails = async (username, jwt) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify({ username: username }),
    };

    const response = await fetch(
      `https://api.dev.quizwizard.net/quiz/getuser`,
      requestOptions
    );
    const data = await response.json();

    //////console.log('Output from the Get User API is ')

    ////console.log("Output from the Get User API is" )
    ////console.log(data)

    set_userdetails(data);
    setUser(data);
    ////console.log(data["batchlist"])
    //  setScore(100)

    ////console.log('getuserDetails done')
    //  setScore(100)

    getEventsfromDB(username, jwt, data['batchlist']);
    ////console.log("Called getEventsfromDB")
  };
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  let event_category_Cards = events_category.map((eventcategory) => {
    return (
      <div className="col-md-4">
        <Col className="py-2 border rounded" key={eventcategory.id}>
          {/* <AssignmentCategoryCard key={eventcategory.id}  eventcategory={eventcategory} /> */}
          <EventCategoryCard
            imgsrc={'../assets/' + eventcategory.category + '.png'}
            title={eventcategory.category}
            key={eventcategory.id}
            eventcategory={eventcategory}
            target="assignmentevents"
          />
        </Col>
      </div>
    );
  });
  return (
    <div>
      <div className={cx(styles.batchBanner)}>
        <img src={batchImg} alt="" />
      </div>



      {false ? (<div className={cx(styles.batchTitle)}>Challenges not enabled for Mobile Platform. Try it in Computers</div>
      ) : <div className={cx(styles.batchTitle)}>My Challenges</div>}

      {loadedcategories ? (
        events_category.length > 0 ? (
          <div>
            <div className={cx(styles.challangeContainer)}>
              <Row>{event_category_Cards}</Row>
            </div>
          </div>
        ) : (
          <p className={styles.subTitle}>No assignments</p>
        )
      ) : (
        <div className={cx(styles.welcomecenter)}>
          <Lottie options={defaultOptions} height={300} width={300} />
        </div>
      )}
    </div>
  );
}
export default AssignmentCategoryScreen;